<template>
	<BaseTooltip :title="subtitle">
		<BaseText
			ref="basetext"
			type="p"
			class="text-dj-grey-dark"
			:class="{
				'line-clamp-1': clamp == 1,
				'line-clamp-2': clamp == 2,
				'line-clamp-3': clamp == 3,
				'line-clamp-4': clamp == 4,
				'line-clamp-5': clamp == 5,
			}"
			data-check-clamp
		>
			{{ subtitle }}
		</BaseText>
	</BaseTooltip>
</template>

<script lang="ts">
import BaseText from "~/ui-kit/components/BaseText.vue";
import BaseTooltip from "~/ui-kit/components/BaseTooltip.vue";

import { ref, onMounted, defineComponent } from "vue";

export default defineComponent({
	name: "DjClampedSubtitle",
	components: {
		BaseText,
		BaseTooltip,
	},
	props: {
		subtitle: {
			type: String,
			default: "Clamped subtitle",
		},
		clamp: {
			type: Number,
			default: 1,
		},
	},
	setup() {
		const basetext = ref<HTMLElement | null>(null);
		const runSecondCheckClamp = ref(true);

		function checkClamp() {
			const clampedNodeList = basetext?.value?.$el;

			if (typeof clampedNodeList !== "undefined") {
				if (clampedNodeList!.scrollHeight > clampedNodeList!.clientHeight + 2) {
					clampedNodeList!.setAttribute("data-check-clamp", "true");
				} else {
					clampedNodeList!.parentElement!.classList.remove("vue-custom-tooltip");
				}
			} else if (runSecondCheckClamp.value == true) {
				// Fallback: slow browsers
				runSecondCheckClamp.value = false;
				setTimeout(() => {
					checkClamp();
				}, 1000);
			}
		}

		onMounted(() => {
			setTimeout(() => {
				checkClamp();
			}, 1);
		});

		return {
			basetext,
		};
	},
});
</script>
